import { render } from "./LoadingIndicator.vue?vue&type=template&id=3618bf7b&scoped=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=3618bf7b&scoped=true&lang=css"

import exportComponent from "/Users/tirinox/Projects/thorviz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3618bf7b"]])

export default __exports__